import { tabCloser, tabTemplate, categoryCodeTab } from '@/layout/state/state';
import { matchSingleUrl } from '@/constants/urls';
import { closeDatasetMarkdown } from '../actions';
import DatasetMarkdownActions from '../components/DatasetMarkdownActions';
import DatasetMarkdownPanel from '../components/DatasetMarkdownPanel';

export default {
  ...tabTemplate(
    'dataset-markdown',
    DatasetMarkdownPanel,
    matchSingleUrl(['datasets', 'markdown']),
    DatasetMarkdownActions,
  ),
  ...tabCloser('closeDatasetMarkdownTab', closeDatasetMarkdown),
  access: ({ datasets }, { isGuest }) => datasets.download && !isGuest,
  componentState: ({ args, url }) => categoryCodeTab(url, args[2]),
  dropDownIcon: 'file outline',
  icon: 'far fa-file',
  order: 220,
};
